export default __webpack_public_path__ + "static/media/enhanced-content.9da83981.svg";